import { Link } from "react-router-dom";
import { Dropdown, Popover, Whisper, Button } from "rsuite";
import styled from "styled-components";
import { Avatar } from "../../Nav/Header/style";
import { MdMoreVert } from "react-icons/md";

const ButtonContainer = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;

  &:hover {
    background: none;
  }
  svg {
    font-size: 16px;
    color: var(--clr-black);
  }
`;

const PopoverContainer = styled(Popover)`
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 5px;
  border: 1px solid var(--clr-white-100);
  background: rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(2px);

  .rs-dropdown-item {
    color: var(--clr-black);
    font-size: 12px;
    font-style: normal;
    font-weight: var(--fw-bold);
    line-height: 16px;
  }
`;

const renderSpeaker = (
  { onClose, left, top, className, ...rest }: any,
  ref: any,
  paymentId?: string
) => {
  const handleSelect = (eventKey: any) => {
    // onClose();
    // console.log(eventKey);
  };
  return (
    <PopoverContainer
      ref={ref}
      className={className}
      style={{ left, top }}
      full
    >
      <Dropdown.Menu onSelect={handleSelect}>
        <Dropdown.Item eventKey={1}>
          <Link
            to={`/payment/view-payment-receipt/${paymentId}`}
            style={{ color: `#000` }}
          >
            View Payment
          </Link>
        </Dropdown.Item>
        {/* <Dropdown.Item eventKey={2}>
          <span style={{ color: `#000` }}>Download Receipt</span>
        </Dropdown.Item> */}
      </Dropdown.Menu>
    </PopoverContainer>
  );
};
interface PaymentMoreProps {
  paymentId?: string;
}

const PaymentMoreDropdown = ({ paymentId }: PaymentMoreProps) => {
  return (
    <Whisper
      placement="bottomStart"
      trigger="click"
      speaker={renderSpeaker(``, ``, paymentId)}
    >
      <ButtonContainer>
        <Avatar>
          <MdMoreVert />
        </Avatar>
      </ButtonContainer>
    </Whisper>
  );
};

export default PaymentMoreDropdown;
